export const installmentsOptions = Array.from({ length: 24 }, (_, i) => i + 1)